// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageCarousel_wrapper__V3XJC","image":"ImageCarousel_image__WqgDX"};